export default {
    companyProfile: {
        dateGenerale: {
            activaFiscal: null,
            adresa: null,
            adresaAnaf: null,
            codCaen: null,
            codInmatriculare: null,
            cui: null,
            dataInregistrarii: null,
            datoriiAnaf: null,
            domeniuActivitate: null,
            emails: null,
            judet: null,
            localitate: null,
            nume: null,
            platitorTva: null,
            telefoane: null,
            vechime: null,
            web: null,
            facebookUrl: null,
            linkedInUrl: null,
            oras: null
        },
        bilanturi: [],
        bilantRecent: null,
        segmentareActivitate: [],
        articole: [],
        topStatistici: {
            national: null,
            regional: null
        },
        seoCompetitors: [],
        oameniCheie: []
    },
    // visible to the user (boolean). When true, UI shows the generic message.
    companyProfileError: false,
    // separate debug field to store developer error details (not shown to users)
    companyProfileDebugError: null,
    companyProfileLoaded: false,
    isMoldovaEnvironment: false
};
